import { useEffect, useState } from "react";

import { SalesRequest } from "~/types/client";

interface UserInfo {
  name: string;
  lastname: string;
  email: string;
}

export function useOrderDialogUsers(
  statusHistory: { changed_by?: string }[] | null,
  getSellerInfo: (id: string) => UserInfo
) {
  const [usersById, setUsersById] = useState<Record<string, UserInfo>>({});

  useEffect(() => {
    if (!statusHistory) return;
    const missingIds = Array.from(
      new Set(
        statusHistory
          .map((h) => h.changed_by)
          .filter(Boolean)
          .filter((uid) => !usersById[uid!])
      )
    ) as string[];

    if (missingIds.length > 0) {
      const newUsers: Record<string, UserInfo> = {};
      missingIds.forEach((id) => {
        newUsers[id] = getSellerInfo(id);
      });
      setUsersById((prev) => ({ ...prev, ...newUsers }));
    }
    // eslint-disable-next-line
  }, [statusHistory, getSellerInfo]);

  return usersById;
}
